import React from "react";
import HeroImage from "../assets/images/Hero.jpg";

const Hero = () => {
  return (
    <section
      className="w-full min-h-screen pt-16 bg-cover bg-center bg-no-repeat flex items-center justify-center px-4"
      style={{
        backgroundImage: `url(${HeroImage})`,
      }}
    >
      <div className="bg-[#3e2c23]/80 backdrop-blur-sm p-6 sm:p-8 md:p-12 rounded-xl border-4 border-[#A9744F] shadow-2xl max-w-5xl w-full text-center text-white">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-fortyTwo uppercase tracking-wider drop-shadow-xl whitespace-normal">
          <span className="text-[#fff8e7]">Tea </span>
          <span className="text-[#fff8e7]">Was </span>
          <span className="text-[#c8ff00]">Fantastic!</span>
        </h1>
        <p className="mt-6 text-base sm:text-lg md:text-2xl font-orbitron text-[#f0e8d9] tracking-wide drop-shadow-sm px-2 sm:px-6 md:px-10 leading-relaxed">
          Pakistan’s Meme Division – Where Chai Meets Chuckles, and Satire Wins Wars
        </p>
      </div>
    </section>
  );
};

export default Hero;
